export default "__VITE_ASSET__BruyGWdR__"